import { render, staticRenderFns } from "./recordDetails.vue?vue&type=template&id=612e02a6&scoped=true"
import script from "./recordDetails.vue?vue&type=script&lang=js"
export * from "./recordDetails.vue?vue&type=script&lang=js"
import style0 from "./recordDetails.vue?vue&type=style&index=0&id=612e02a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e02a6",
  null
  
)

export default component.exports